import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoggedInUserService } from '../../../auth/logged.in.user';
import { CmsHelpService, FaqUserType } from '../../../services/cms.help.service';

@Component({
    selector: 'help-bid-management',
    template: require('./help.bid-management.component.html'),
    styles: [require('../personal.account.shared.css'), require('./help.bid-management.component.css')]
})
export class HelpBidManagementComponent implements OnInit, OnDestroy {
    content = '';

    constructor(
        private readonly cmsHelpService: CmsHelpService,
        private readonly userService: LoggedInUserService) { }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');

        const loggedInUser = this.userService.getCurrentUser();
        const isBidManager = loggedInUser.canAdHoc('bidManagerDashboard');
        const userType = loggedInUser.canAdHoc('notSubscribed')
            ? FaqUserType.Free
            : isBidManager ? FaqUserType.BidManager : FaqUserType.BidTeamMember;

        this.cmsHelpService.getByUserType(userType).subscribe((response: any) => {
            this.content = (response && response.result && response.result.content) || '';
        });
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/help/help.bid-management.component.ts